import * as React from 'react';
import { useMediaQuery } from "@mui/material";

import {
    TextField,
    Tooltip,
    Grid,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useTranslate } from "react-redux-multilingual";
import { Visibility, InfoOutlined } from "@mui/icons-material";
import { Warning } from '@mui/icons-material';
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';


const userauth = ({ formik, userInfo, route, emailId }) => {
    const [passwordVisible, setpasswordVisible] = React.useState(false);
    const [confirmPasswordVisible, setconfirmPasswordVisible] = React.useState(false);
    const t = useTranslate();
    const matches = useMediaQuery('(min-width:500px)');
    const store = useSelector(state => state);
    const dispatch = useDispatch();
    const alertStyling1 = { color: 'red', fontSize: '35px', position: 'absolute', top: '23px', right: '-85px' }
    const alertStyling2 = { color: 'red', fontSize: '35px', position: 'absolute', top: '13px', left: '-33px' }
    const PasswordVisibleHandler = () => setpasswordVisible(!passwordVisible)
    const ConfirmPasswordVisibleHandler = () => setconfirmPasswordVisible(!confirmPasswordVisible)


    return (

        <>

            <Grid container style={{
                display: 'flex',
                justifyContent: 'center',
                alignContent: 'center',
            }}>

                <div style={{ padding: "2em" }}>
                    <div style={{ position: 'relative' }}>
                        <TextField
                            sx={{ margin: '13px', width: `${matches ? '33rem' : '16rem'}` }}
                            id="email"
                            name="email"
                            label={t('emailAddress')}
                            required
                            value={emailId}
                            onChange={formik.handleChange}
                            error={formik.touched.email && Boolean(formik.errors.email)}
                            helperText={formik.touched.email && formik.errors.email}
                            InputLabelProps={{
                                sx: {
                                    '& .MuiFormLabel-asterisk': {
                                        color: 'red',
                                    },
                                },
                                '&.MuiInputLabel-shrink': {
                                    fontSize: '1.5rem', // Works when label shrinks (i.e., floats)
                                  },
                                  transition: 'all 0.2s ease', // Make it a bit bigger when focused
                                
                            }}
                        />
                    </div>

                    <div style={{ position: 'relative' }}>
                        {
                            <TextField
                                sx={{ margin: '13px', width: `${matches ? '33rem' : '16rem'}` }}
                                label={t('setPassword')}
                                onChange={formik.handleChange}
                                value={formik.values.Password}
                                required
                                id="Password"
                                name="Password"
                                autoComplete="new-password"
                                type={passwordVisible ? "text" : "password"}
                                error={formik.touched.Password && Boolean(formik.errors.Password)}
                                helperText={(formik.touched.Password && formik.errors.Password)}
                                InputLabelProps={{
                                    sx: {
                                        '& .MuiFormLabel-asterisk': {
                                            color: 'red',
                                        },
                                    },
                                    '&.MuiInputLabel-shrink': {
                                        fontSize: '1.5rem', // Works when label shrinks (i.e., floats)
                                      },
                                      transition: 'all 0.2s ease', // Make it a bit bigger when focused
                                    
                                }}
                                />
                        }

                        {
                            <Visibility onMouseEnter={PasswordVisibleHandler} onMouseLeave={PasswordVisibleHandler} sx={{ position: 'absolute', color: '#4D4E4E', top: '30px', right: '30px' }} />
                        }
                    </div>
                    <div style={{ position: 'relative' }}>
                        {
                            <TextField
                                sx={{ margin: '13px', width: `${matches ? '33rem' : '16rem'}` }}
                                label={t('confirmPassword')}
                                required
                                value={formik.values.confirmPassword}
                                id="confirmPassword"
                                name="confirmPassword"
                                autoComplete="new-password"
                                onChange={formik.handleChange}
                                type={confirmPasswordVisible ? "text" : "password"}
                                error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
                                helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
                                InputLabelProps={{
                                    sx: {
                                        '& .MuiFormLabel-asterisk': {
                                            color: 'red',
                                        },
                                    },
                                    '&.MuiInputLabel-shrink': {
                                        fontSize: '1.5rem', // Works when label shrinks (i.e., floats)
                                      },
                                      transition: 'all 0.2s ease', // Make it a bit bigger when focused
                                    
                                }}
                            />
                        }

                        {
                            <Visibility onMouseEnter={ConfirmPasswordVisibleHandler} onMouseLeave={ConfirmPasswordVisibleHandler} sx={{ position: 'absolute', color: '#4D4E4E', top: '30px', right: '30px' }} />
                        }
                        <Tooltip title={
                            <p>{t('passwordRule1')}
                                <br /><br />
                                {t('passwordRule2')}
                            </p>}>
                            <InfoOutlined sx={{ fontSize: '35px', color: '#4D4E4E', position: 'absolute', top: '25px', right: '-40px' }} />
                        </Tooltip>
                        {
                            (formik.values.Password?.length !== 0 && formik.values.confirmPassword?.length !== 0) &&
                            (formik.values.Password !== formik.values.confirmPassword ?
                                <Tooltip title={t('passwordmatchAlert')}>
                                    <Warning sx={matches ? alertStyling1 : alertStyling2} />
                                </Tooltip>
                                :
                                <Tooltip title={t('passwordmatchSuccess')}>
                                    <DoneOutlinedIcon sx={{ color: 'green', fontSize: '35px', position: 'absolute', top: '23px', right: '-90px' }} />
                                </Tooltip>)
                        }

                    </div>
                </div>

            </Grid>



        </>
    )
}

export default userauth;